import {useContext} from 'react'
import {CustomLanding36252Context} from '../../reducer'
import {Container} from './components/Container'
import {Heading} from '../Heading'
import {t} from '../../i18n'
import {Red} from '../Red'
import {Row} from './components/Row'
import {Step} from './components/Step'
import {ReactComponent as Wallet} from '../../assets/wallet.svg'
import {StepHeader} from './components/StepHeader'
import {ReactComponent as Rocket} from '../../assets/rocket.svg'
import {ReactComponent as Stonks} from '../../assets/stonks.svg'
import {BodyText} from '../BodyText'

export const Steps = () => {
  const [state] = useContext(CustomLanding36252Context)
  return (
    <Container>
      <Heading>
        {t[state.language].stepsHeader}
        <Red> {t[state.language].stepsHeaderRed}</Red>
      </Heading>
      <Row>
        <Step>
          <Wallet />
          <StepHeader>{t[state.language].registerAndFund}</StepHeader>
          <BodyText>{t[state.language].depositMinimum}</BodyText>
        </Step>
        <Step>
          <Rocket />
          <StepHeader>{t[state.language].get50Bonus}</StepHeader>
          <BodyText>{t[state.language].receive50Deposit}</BodyText>
        </Step>
        <Step>
          <Stonks />
          <StepHeader>{t[state.language].startTrading}</StepHeader>
          <BodyText>{t[state.language].trade25}</BodyText>
        </Step>
      </Row>
    </Container>
  )
}
